<span
  *ngrxLet="settings$; let settings"
  class="link"
  [class.link--disabled]="isChangeDisabled$ | async"
  (click)="changeLeverage()"
  >
  @switch (!!settings.current) {
    @case (true) {
      1:<bdi>{{ settings.current }}</bdi>
    }
    @default {
      -
    }
  }
</span>
